import { useAnalyticsClient } from '@acorns/web-utils'

import { useUpdateVerificationProfileMutation } from 'generated/types'

export const useCaptureDeviceSessionId = () => {
  const [updateVerificationProfile] = useUpdateVerificationProfileMutation()
  const analytics = useAnalyticsClient()

  return () => {
    return window.SigmaDeviceManager?.getSessionToken()
      .then((deviceSessionId: string) => {
        return updateVerificationProfile({ variables: { deviceSessionId } })
      })
      .catch((error: any) => {
        analytics.track('Error Received', {
          eventData: {
            object_name: 'updateVerificationProfileError',
            error_details: error,
          },
        })
      })
  }
}
